import React from 'react';
import {TextField} from '@material-ui/core';
import {FormGroup} from 'react-bootstrap';

export class Input extends React.Component {
  render() {
    const {
      input,
      label,
      type,
      required,
      placeholder,
      helpText,
      meta: {error, warning, touched},
      ...props
    } = this.props;

    const errorMsg = touched && (error || warning);

    const asterisk = required && <span className="form-field-required" />;

    return (
      <FormGroup>
        <TextField
          {...{
            ...input,
            onBlur: () => input.onBlur(input.value),
            type,
            helperText: errorMsg || helpText,
            error: !!errorMsg,
            label: (
              <span>
                {label} {asterisk}
              </span>
            ),
            placeholder,
            ...props,
          }}
        />
        {helpText && <span className="help-text">{helpText}</span>}
      </FormGroup>
    );
  }
}
